import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12 col-lg-12 col-xxxl-12" }
const _hoisted_12 = { class: "col-md-12 col-xxl-12" }
const _hoisted_13 = { class: "col-md-12 col-xxl-12" }
const _hoisted_14 = { class: "col-md-12 col-lg-12 col-xxxl-12" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-xxl-7 col-xxxl-6\"></div><div class=\"col-xxl-5 col-xxxl-6\"></div><div class=\"col-xxl-4\"></div><div class=\"col-xxl-4\"></div><div class=\"col-xxl-4\"></div><div class=\"col-xxl-6\"></div></div>", 1)

import { defineComponent, reactive ,onMounted } from "vue";
import storeControle from "@/utils/storeControle";

import WhatHappening from "../../components/Dashboard/Ecommerce/WhatHappening.vue";

import StatBox from "../../components/Dashboard/Ecommerce/StatsBoxes/index.vue";

import PrevisaoReceber from "../../components/Dashboard/Ecommerce/PrevisaoReceber.vue";

import PrevisaoGrid from "../../components/Dashboard/Ecommerce/PrevisaoGrid/index.vue";

import ExpectedEarnings from "../../components/Dashboard/Ecommerce/ExpectedEarnings.vue";

import AverageDailySales from "../../components/Dashboard/Ecommerce/AverageDailySales.vue";

import RevenueThisMonth from "../../components/Dashboard/Ecommerce/RevenueThisMonth.vue";

import NewCustomersThisMonth from "../../components/Dashboard/Ecommerce/NewCustomersThisMonth.vue";



import WeeklySales from "../../components/Dashboard/Ecommerce/WeeklySales.vue";

import SalesByPOSLocation from "../../components/Dashboard/Ecommerce/SalesByPOSLocation.vue";

import TopSellingProducts from "../../components/Dashboard/Ecommerce/TopSellingProducts/index.vue";

import WebsiteVisitors from "../../components/Dashboard/Ecommerce/WebsiteVisitors.vue";

import ProductsOrders from "../../components/Dashboard/Ecommerce/ProductsOrders/index.vue";

import ProjetoExpansao  from "../../components/Dashboard/Ecommerce/ProjetoExpansao/index.vue";

import ProjetoCustos  from "../../components/Dashboard/Ecommerce/ProjetoCustos/index.vue";

import ResumoCidade from "../../components/Dashboard/Ecommerce/ResumoCidade.vue";

import * as serviceDashboard from "@/services/DashboardInvestidor";
import {usuarioLogado, f2dec} from "@/utils/funcoes";


export default /*#__PURE__*/_defineComponent({
  __name: 'EcommercePage',
  setup(__props) {


var controle = reactive({
  dashboard: {} as serviceDashboard.Dashboard ,
  atualizando: false,
  status: "",
  erro: "",
})

onMounted(async ()=> {


  console.log("buscando...")
  controle.status = "Buscando dados...";

  var usuario = usuarioLogado();

  var param = {
    investidoresId:[usuario?.usuarioId],
    somarcortesias: false

  } as serviceDashboard.FiltroMensalidades;

  controle.atualizando = true;

  serviceDashboard.obterDashboard(param)
  .then(r=> {
    controle.dashboard = r;
    controle.status = "";
    controle.atualizando = false;
  })
  .catch(erro => {
    controle.status = "";
    controle.erro = erro;
    controle.atualizando = false;
  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_unref(controle).status) + " ", 1),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(WhatHappening, {
          "nome-usuario": _unref(storeControle).usuario?.nomeUsuario,
          "qtde-contratos": _unref(controle).dashboard.qtdeContratos,
          "total-contratos": _unref(controle).dashboard.totalContratos,
          "perc-investidor": _unref(controle).dashboard.percInvestidor,
          atualizando: _unref(controle).atualizando
        }, null, 8, ["nome-usuario", "qtde-contratos", "total-contratos", "perc-investidor", "atualizando"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(StatBox, {
          class: _normalizeClass('text-primary'),
          icon: 'flaticon-marker',
          title: 'CIDADES',
          sign: '',
          "current-value": _unref(controle).dashboard?.resumoCidades?.length.toString(),
          "previous-value": 0,
          "class-two": 'text-success',
          percent: 0,
          "icon-up-down": 'flaticon-up-arrow',
          atualizando: _unref(controle).atualizando
        }, null, 8, ["current-value", "atualizando"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(StatBox, {
          class: _normalizeClass('text-primary'),
          icon: 'flaticon-form',
          title: 'CONTRATOS',
          sign: '',
          "current-value": _unref(controle).dashboard?.qtdeContratos?.toString(),
          "previous-value": 13.456,
          "class-two": 'text-success',
          percent: 5.5,
          "icon-up-down": 'flaticon-up-arrow',
          atualizando: _unref(controle).atualizando
        }, null, 8, ["current-value", "atualizando"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(StatBox, {
          class: _normalizeClass('text-secondary'),
          icon: 'flaticon-menu',
          title: 'TOTAL MES',
          sign: 'R$ ',
          "current-value": _unref(f2dec)(_unref(controle).dashboard?.totalParcelasMes),
          "previous-value": _unref(f2dec)(_unref(controle).dashboard?.totalParcelasMes * _unref(controle).dashboard.percInvestidor / 100),
          "view-previus": true,
          "class-two": 'text-success',
          percent: 100,
          "view-percent": true,
          "icon-up-down": '',
          atualizando: _unref(controle).atualizando
        }, null, 8, ["current-value", "previous-value", "atualizando"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(StatBox, {
          class: _normalizeClass('text-success'),
          icon: 'flaticon-check',
          title: 'RECEBIDO MES',
          sign: 'R$ ',
          "current-value": _unref(f2dec)(_unref(controle).dashboard?.totalParcelasRecebidasMes),
          "previous-value": _unref(f2dec)(_unref(controle).dashboard?.totalParcelasRecebidasMes * _unref(controle).dashboard.percInvestidor / 100),
          "view-previus": true,
          "class-two": 'text-success',
          percent: _unref(controle).dashboard?.totalParcelasRecebidasMes / _unref(controle).dashboard?.totalParcelasMes * 100,
          "view-percent": true,
          "icon-up-down": '',
          atualizando: _unref(controle).atualizando
        }, null, 8, ["current-value", "previous-value", "percent", "atualizando"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(StatBox, {
          class: _normalizeClass('text-danger'),
          icon: 'flaticon-date-1',
          title: 'PENDENTE MES',
          sign: 'R$ ',
          "current-value": _unref(f2dec)(_unref(controle).dashboard?.totalParcelasMes - _unref(controle).dashboard.totalParcelasRecebidasMes),
          "previous-value": _unref(f2dec)((_unref(controle).dashboard?.totalParcelasMes - _unref(controle).dashboard.totalParcelasRecebidasMes) * _unref(controle).dashboard.percInvestidor / 100),
          "view-previus": true,
          "class-two": 'text-danger',
          percent: (_unref(controle).dashboard?.totalParcelasMes - _unref(controle).dashboard.totalParcelasRecebidasMes) / _unref(controle).dashboard?.totalParcelasMes * 100,
          "view-percent": true,
          "icon-up-down": '',
          atualizando: _unref(controle).atualizando
        }, null, 8, ["current-value", "previous-value", "percent", "atualizando"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).dashboard.resumoCidades, (cidade, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-md-6 col-lg-6 col-xxxl-6",
          key: idx
        }, [
          _createVNode(ResumoCidade, {
            "resumo-cidade": cidade,
            atualizando: _unref(controle).atualizando,
            "total-todas-cidades": _unref(controle).dashboard.totalContratos
          }, null, 8, ["resumo-cidade", "atualizando", "total-todas-cidades"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(WeeklySales, {
          planejado: _unref(controle).dashboard.planejado,
          previsao: _unref(controle).dashboard.previsao,
          atualizando: _unref(controle).atualizando
        }, null, 8, ["planejado", "previsao", "atualizando"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(ProjetoExpansao)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(ProjetoCustos)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(PrevisaoGrid, {
          previsao: _unref(controle).dashboard.previsao,
          atualizando: _unref(controle).atualizando
        }, null, 8, ["previsao", "atualizando"])
      ])
    ]),
    _hoisted_15
  ], 64))
}
}

})